import { render, staticRenderFns } from "./CollapsibleSection.vue?vue&type=template&id=77605a6b&scoped=true"
import script from "./CollapsibleSection.vue?vue&type=script&lang=ts"
export * from "./CollapsibleSection.vue?vue&type=script&lang=ts"
import style0 from "./CollapsibleSection.vue?vue&type=style&index=0&id=77605a6b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77605a6b",
  null
  
)

export default component.exports